export default __webpack_public_path__ + "static/S&FSharp-Bold-ea590ea84fc298fa166e367c25906f3a.woff";